export function LandingHeroRoadBackground({ muted = false }: { muted?: boolean } = {}) {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 overflow-hidden"
      style={{
        background: [
          'linear-gradient(180deg, rgb(var(--theme-surface) / 0.97) 0%, rgb(var(--theme-bg) / 0.9) 72%, rgb(var(--theme-bg) / 0) 100%)',
          'radial-gradient(circle at 84% 10%, rgb(var(--theme-secondary) / 0.06), transparent 18rem)',
        ].join(', '),
      }}
    >
      <svg
        className={`absolute inset-x-[-10%] top-4 h-[42rem] w-[120%] sm:top-0 sm:h-[48rem] ${muted ? 'opacity-35' : 'opacity-75'}`}
        viewBox="0 0 900 620"
        preserveAspectRatio="none"
        fill="none"
      >
        <path d="M-60 36 C220 42 498 72 654 152 C792 223 772 312 610 358 C412 414 282 442 306 548 C318 602 366 646 436 686" stroke="rgb(var(--theme-secondary) / 0.36)" strokeWidth="1.2" />
        <path d="M-80 76 C206 80 462 104 596 174 C704 230 698 286 568 326 C382 384 226 416 228 526 C230 590 282 638 352 690" stroke="rgb(var(--theme-secondary) / 0.25)" strokeWidth="1" />
        <path d="M-70 122 C184 124 394 142 508 198 C602 244 602 288 488 322 C304 376 144 410 118 518 C102 586 142 638 214 694" stroke="rgb(var(--theme-highlight) / 0.28)" strokeWidth="1" />
        <path d="M-50 178 C172 176 322 186 414 228 C492 264 486 302 382 334 C212 386 58 420 10 518 C-26 592 4 650 76 708" stroke="rgb(var(--theme-secondary) / 0.22)" strokeWidth="1" strokeDasharray="8 9" />
        <path d="M-90 250 C120 238 252 232 340 262 C424 291 420 330 310 362 C138 412 -12 458 -84 548 C-134 610 -126 668 -54 724" stroke="rgb(var(--theme-highlight) / 0.18)" strokeWidth="1" strokeDasharray="7 10" />
        <path d="M620 36 L792 36" stroke="rgb(var(--theme-secondary) / 0.16)" strokeWidth="1" />
        <path d="M702 286 L916 286" stroke="rgb(var(--theme-highlight) / 0.16)" strokeWidth="1" />
        <path d="M642 398 L812 398" stroke="rgb(var(--theme-secondary) / 0.12)" strokeWidth="1" />
      </svg>
    </div>
  );
}
